export const copyToClipboard = async (text) => {
	if (navigator.clipboard && navigator.permissions) {
		return navigator.clipboard.writeText(text)
	}
}
